import * as React from "react";
import { PublishOrEditRunbookSnapshot } from "./PublishOrEditRunbookSnapshot";
export function PublishNewSnapshotPage() {
    return <PublishOrEditRunbookSnapshot />;
}
